// Stored in the DB as these snake_case keys; ROLE_LABELS gives the friendly names.
export enum UserRoles {
  SuperAdmin = "super_admin",
  Admin = "admin",
  Employee = "employee",
}

export const ROLE_LABELS: Record<string, string> = {
  [UserRoles.SuperAdmin]: "Super Admin",
  [UserRoles.Admin]: "Admin",
  [UserRoles.Employee]: "Employee",
};

// Super Admin is deliberately not assignable/visible anywhere in the admin UI.
export const ASSIGNABLE_ROLES = [UserRoles.Admin, UserRoles.Employee];

export interface User {
  id?: number;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone: number;
  verification_url?: string;
  is_verified?: boolean;
  created_at?: Date;
  updated_at?: Date;
  role: UserRoles;
  token: string;
  deleted_at: Date;
  username: string;
  max_bookings: number;
}


export interface Client {
  id?: number;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  guid:string;
  verified:string;
  phone: number;
  verification_code?: string;
  fcm_token:string;
  created_at?: Date;
  updated_at?: Date;
  deleted_at: Date;
}
